import {AfterViewInit, Component, ElementRef, Input, ViewChild} from '@angular/core';
import {Tooltip} from 'foundation-sites/js/foundation.tooltip';
import $ from 'jquery';

@Component({
    selector: 'a-tooltip',
    templateUrl: './a-tooltip.component.html',
    styleUrls: ['./a-tooltip.component.scss'],
    standalone: false
})
export class ATooltipComponent implements AfterViewInit {

    @Input() title: string;
    @ViewChild('el') el: ElementRef;

    ngAfterViewInit(): void {
        new Tooltip($(this.el.nativeElement));
    }

    @Input()
    public bottom: boolean;
}
